module.exports = __webpack_public_path__ + "static/kontakt-8c9627f819aa99a0b8abc47f0ce87b15.jpg";